import { AlertTypeEnum } from "./AlertTypeEnum";
import { AlertTypeContract } from "./AlertTypeContract";

export class AlertTypeMapper {
  toContract(enumValue: AlertTypeEnum | string): AlertTypeContract {
    if (typeof enumValue === "string") {
      return enumValue as unknown as AlertTypeContract;
    }
    return enumValue as unknown as AlertTypeContract;
  }

  toEnum(contractValue: AlertTypeContract | string): AlertTypeEnum {
    if (typeof contractValue === "string") {
      return AlertTypeEnum[contractValue as keyof typeof AlertTypeEnum];
    }
    return contractValue as unknown as AlertTypeEnum;
  }
}
